import React from 'react';

interface ScribeEmbedProps {
  scribeId: string;
  title?: string;
}

export default function ScribeEmbed({ scribeId, title }: ScribeEmbedProps) {
  // Scribe embed URL format - adjust based on your Scribe setup
  // Common formats:
  // - https://scribehow.com/embed/[ID]
  // - https://www.scribehow.com/embed/[ID]
  // - Custom domain format

  const embedUrl = `https://scribehow.com/embed/${scribeId}`;

  return (
    <div className="my-6">
      <div className="relative w-full" style={{ paddingBottom: '56.25%' }}> {/* 16:9 aspect ratio */}
        <iframe
          src={embedUrl}
          className="absolute top-0 left-0 w-full h-full rounded-lg border border-gray-200"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={title || `Scribe tutorial ${scribeId}`}
        />
      </div>
    </div>
  );
}

